// /**
//  * Parcel-Sender -CSV
//  */

// React
import React from 'react';

import {CSVLink} from 'react-csv';

// UI
import {Button} from '@material-ui/core';

import jMoment from 'moment-jalaali';

// Icon
import Icon from '@mdi/react';
import {mdiTableArrowUp} from '@mdi/js';
import {ProductCSV} from './interfaces';

type Props = {
  parcelsDispatch: any;
  data: ProductCSV[];
  filtersValues: any;
  loading: boolean;
};

function CSV(props: Props) {
  const headers = [
    { label: "نام کالا", key: "name" },
    { label: "کد کالا", key: "code" },
    { label: "دسته بندی", key: "categoryName" },
    { label: "موجودی کالا ( شامل موجودی کل)", key: "sumCount" }
  ];
  const handleCreateCSV = () => {
    props.parcelsDispatch({...props.filtersValues, size: 10000});
  };
  const flattData = (data: any) => {
    const newData = data.map((item: any) => {
      return {
        name: item.name,
        code: item.code,
        categoryName: item.categoryName ?? 'نا مشخص',
        sumCount: item.sumCount,
      };
    });
    return newData;
  };

  return (
    <>
      {props.data.length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          headers={headers}
          separator={","}
          filename="Product.csv"
          style={{
            backgroundColor: '#DFA01F',
            padding: '8px 15px',
            color: '#fff',
            marginLeft: '5px',
            textDecoration: 'none',
            borderRadius: '5px',
          }}
        >
          دانلود CSV
        </CSVLink>
      ) : (
        <Button
          style={{marginLeft: '5px'}}
          variant="contained"
          color="primary"
          startIcon={<Icon path={mdiTableArrowUp} size={1} />}
          onClick={handleCreateCSV}
          disabled={props.loading}
        >
          ایجاد فایل CSV
        </Button>
      )}
    </>
  );
}

export default CSV;
